module.exports = __webpack_public_path__ + "static/media/notification.b73b8f82.png";